export default __webpack_public_path__ + "static/media/logo-nav.5422ffe3.png";